/**
 * Judge.me Review Card Enhancer — xinzuo.com.au
 * Injects product thumbnail images into review cards on the all-reviews page.
 * Uses Shopify AJAX API to fetch product images by handle.
 */
(function () {
  var cache = {};
  var pending = {};

  function getProductImage(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    if (pending[handle]) return pending[handle];

    pending[handle] = fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var img = data.product && data.product.featured_image
          ? data.product.featured_image
          : (data.product && data.product.images && data.product.images[0])
            ? data.product.images[0]
            : null;
        if (img && typeof img === 'object') img = img.src;
        // Request a small size from Shopify CDN
        if (img) img = img.replace(/\.([a-z]+)(\?|$)/, '_180x180_crop_center.$1$2');
        cache[handle] = img;
        delete pending[handle];
        return img;
      })
      .catch(function () {
        cache[handle] = null;
        delete pending[handle];
        return null;
      });

    return pending[handle];
  }

  function enhanceReview(rev) {
    if (rev.dataset.thumbEnhanced) return;
    rev.dataset.thumbEnhanced = '1';

    var link = rev.querySelector('a.jdgm-rev__prod-link');
    if (!link || !link.href) return;

    var match = link.getAttribute('href').match(/\/products\/([^#?/]+)/);
    if (!match) return;

    var handle = match[1];
    getProductImage(handle).then(function (src) {
      if (!src) return;
      var img = document.createElement('img');
      img.className = 'jdgm-rev__product-thumb';
      img.src = src;
      img.alt = (link.textContent || '').trim();
      img.width = 80;
      img.height = 80;
      img.loading = 'lazy';
      img.onerror = function () { img.remove(); rev.classList.remove('has-product-thumb'); };
      rev.prepend(img);
      rev.classList.add('has-product-thumb');
    });
  }

  function enhanceAll() {
    var revs = document.querySelectorAll('.jdgm-rev:not([data-thumb-enhanced])');
    revs.forEach(enhanceReview);
  }

  // Run once DOM-ready reviews exist, then watch for Load More additions
  var observer = new MutationObserver(function (mutations) {
    var hasNew = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { hasNew = true; break; }
    }
    if (hasNew) { enhanceAll(); customizeAllForms(); scheduleA11y(); }
  });

  /* ---------- Accessibility of the Judge.me widgets (PDP product widget, /pages/reviews all-reviews widget) ----------
     Judge.me renders asynchronously and re-renders on sort, tab, star filter and LOAD MORE, so every pass is
     idempotent and runs again (debounced) whenever nodes are added. */
  var a11yTimer = null;
  function scheduleA11y() {
    clearTimeout(a11yTimer);
    a11yTimer = setTimeout(a11yPass, 50);
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function isShown(el) {
    if (!el || !el.isConnected) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.getClientRects().length > 0;
  }

  // Page scroll lock while the write-review modal is open: the theme's own @theme/dialog lock (sticky positioning and
  // the scrollbar survive; scrollable regions inside the modal still scroll). This is a classic script, so the module
  // loads on demand. ES2015 syntax on purpose: Shopify's asset minifier lowers an all-ES5 file to ES5 and turns
  // import() into require() (undefined in the browser); with let/arrow functions it keeps import(), as in
  // xz-v2-info-popup.js and cart-engraving.js. Without import maps (Chrome < 89) the modal simply stays unlocked.
  let dialogModule = null;
  const withDialog = (callback) => {
    if (dialogModule) { callback(dialogModule); return; }
    try { import('@theme/dialog').then((module) => { dialogModule = module; callback(module); }).catch(() => {}); } catch (e) { /* no dynamic import */ }
  };

  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  function watchState(el) {
    if (!watched || watched.has(el)) return;
    watched.add(el);
    new MutationObserver(scheduleA11y).observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'open'] });
  }

  // Write-review modal steps (PDP). Picking a star re-renders the modal to its next step and focus falls to <body>, so a
  // screen reader announces nothing; Judge.me also hides its close button after the first step (inline opacity 0,
  // aria-hidden, tabindex -1) although the theme's display:flex keeps it clickable. Watching the modal's step classes:
  // the close button stays a visible, named Tab stop on every step (xz-v2-pdpf-below.css shows it), and lost focus moves
  // into the step shown: its first field after a key press (Enter on a star), its title after a tap or click (no
  // on-screen keyboard popping up, as the engraving fields).
  var lastInputKey = false;
  document.addEventListener('keydown', function () { lastInputKey = true; }, true);
  document.addEventListener('pointerdown', function () { lastInputKey = false; }, true);
  var stepWatched = typeof WeakSet === 'function' ? new WeakSet() : null;
  function watchSteps(modal) {
    if (!stepWatched || stepWatched.has(modal)) return;
    stepWatched.add(modal);
    // Checked shortly after a step class change and again once Judge.me's slide has settled (the old step may be hidden
    // only then); a focusout with nowhere to go is checked the same way, remembering the control that lost focus.
    var timers = [];
    var lostFrom = null;
    var schedule = function () {
      timers.forEach(clearTimeout);
      timers = [setTimeout(function () { syncModalStep(modal, lostFrom); }, 30), setTimeout(function () { syncModalStep(modal, lostFrom); lostFrom = null; }, 400)];
    };
    new MutationObserver(schedule).observe(modal, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden', 'tabindex'] });
    modal.addEventListener('focusout', function (event) { if (!event.relatedTarget) { lostFrom = event.target; schedule(); } });
  }
  function firstShown(root, selector) {
    var list = root.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) if (isShown(list[i]) && !list[i].disabled && list[i].tabIndex >= 0) return list[i];
    return null;
  }
  function syncModalStep(modal, lostFrom) {
    if (!isShown(modal)) return;
    var close = modal.querySelector('.jdgm-write-review-modal__close-btn');
    if (close) {
      if (close.getAttribute('aria-hidden') === 'true') close.removeAttribute('aria-hidden');
      if (close.getAttribute('tabindex') === '-1') close.removeAttribute('tabindex');
    }
    var page = modal.querySelector('.current-section .current-page') || modal.querySelector('.current-section');
    if (!page) return;
    var now = Date.now();
    if (page !== modal.__xzStepPage) { modal.__xzStepPage = page; modal.__xzStepAt = now; }
    // Lost to a step change: still on a control of the step just hidden (before Chrome's focus fixup), or on <body>
    // within 1.5s of the change or after the focused control itself was hidden. A deliberate blur (a click on empty
    // space) is left alone.
    var active = document.activeElement;
    var onBody = !active || active === document.body || active === document.documentElement;
    var hiddenActive = !onBody && modal.contains(active) && !isShown(active);
    if (!hiddenActive && !(onBody && (now - modal.__xzStepAt < 1500 || (lostFrom && !isShown(lostFrom))))) return;
    var target = null;
    if (lastInputKey) target = firstShown(page, '.jdgm-write-review-modal__field-input') || firstShown(page, 'input:not([type=hidden]), textarea, select, button, a[href]');
    if (!target) {
      var titles = page.querySelectorAll('.jdgm-write-review-modal__title, .jdgm-write-review-modal__product-title');
      for (var i = 0; i < titles.length; i++) if (isShown(titles[i])) { target = titles[i]; break; }
      if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    }
    if (!target && close && isShown(close)) target = close;
    if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
  }

  var modalLocked = null;
  // "Write a review" opens Judge.me's modal (PDP) or its inline form (/pages/reviews); its aria-expanded stays false
  // in Judge.me's markup, so it follows what is actually shown.
  function syncWriteState() {
    var modal = null;
    var modals = document.querySelectorAll('.jdgm-write-review-modal');
    for (var i = 0; i < modals.length; i++) { watchState(modals[i]); watchSteps(modals[i]); if (isShown(modals[i])) modal = modals[i]; }
    document.querySelectorAll('.jdgm-write-rev-link').forEach(function (link) {
      var widget = link.closest('.jdgm-widget') || document;
      var form = widget.querySelector('.jdgm-form-wrapper');
      if (form) watchState(form);
      setAttr(link, 'aria-expanded', (modal || isShown(form)) ? 'true' : 'false');
    });
    if (modal && modalLocked !== modal) {
      var previous = modalLocked;
      modalLocked = modal;
      withDialog(function (module) {
        if (previous) module.unlockScroll(previous);
        if (modalLocked === modal && isShown(modal)) module.lockScroll(modal);
      });
    } else if (!modal && modalLocked) {
      var closed = modalLocked;
      modalLocked = null;
      withDialog(function (module) { module.unlockScroll(closed); });
    }
  }

  // Judge.me's sort label is centred with its chevron 8px after it (the PDP's .xz-dropdown-btn recipe): the CSS needs
  // the selected label's width (--xz-sort-w). The PDP's own reviews element sizes its select; this covers /pages/reviews.
  var sortCanvas = null;
  function sizeSort(select) {
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var cs = window.getComputedStyle(select);
    var ctx = sortCanvas || (sortCanvas = document.createElement('canvas').getContext('2d'));
    if (!ctx) return;
    ctx.font = cs.fontWeight + ' 14px ' + cs.fontFamily;
    if (document.fonts && document.fonts.check && !document.fonts.check(ctx.font, option.text)) return;
    var value = Math.round(ctx.measureText(option.text.toUpperCase()).width * 100) / 100 + 'px';
    if (select.style.getPropertyValue('--xz-sort-w') !== value) select.style.setProperty('--xz-sort-w', value);
  }

  function a11yPass() {
    // Star ratings are role=img: readable, but not Tab stops (5-6 useless stops per page).
    document.querySelectorAll('.jdgm-rev__rating[tabindex="0"]').forEach(function (el) { setAttr(el, 'tabindex', '-1'); });
    // Summary stars: an image of the average. Where it also holds the "4.80 out of 5" link, it is a labelled group
    // instead (an img may not contain a focusable control) and the stars themselves are decorative.
    document.querySelectorAll('.jdgm-rev-widg__summary-stars, .jdgm-all-reviews__summary-stars').forEach(function (el) {
      if (el.querySelector('a[href], button, [tabindex="0"]')) {
        setAttr(el, 'role', 'group');
        el.querySelectorAll('.jdgm-star').forEach(function (star) { setAttr(star, 'aria-hidden', 'true'); });
      }
      if (el.hasAttribute('tabindex')) el.removeAttribute('tabindex');
    });
    // Review photo links: "<reviewer> review photo N", as Judge.me's product widget names them; the All Reviews
    // widget leaves them unnamed or with the generic alt "User picture".
    document.querySelectorAll('.jdgm-rev').forEach(function (rev) {
      var links = rev.querySelectorAll('a.jdgm-rev__pic-link');
      if (!links.length) return;
      var author = rev.querySelector('.jdgm-rev__author');
      var who = author ? author.textContent.trim() : '';
      links.forEach(function (link, index) {
        if (link.getAttribute('aria-label')) return;
        link.setAttribute('aria-label', (who ? who + ' review photo ' : 'Review photo ') + (index + 1));
      });
    });
    // /pages/reviews: Product / Shop reviews tabs are role=button toggles; say which one is showing.
    document.querySelectorAll('.jdgm-subtab__name[role="button"]').forEach(function (tab) {
      setAttr(tab, 'aria-pressed', tab.classList.contains('jdgm--active') ? 'true' : 'false');
      watchState(tab);
    });
    // /pages/reviews: "Based on 710 Reviews" (the PDP's wording) and the medal row's link named by its visible text.
    document.querySelectorAll('.jdgm-all-reviews__summary-text').forEach(function (based) {
      var node = based.firstChild;
      if (!node || node.nodeType !== 3) return;
      var text = node.nodeValue.replace(/\breviews\b/, 'Reviews').replace(/\breview\b/, 'Review');
      if (text !== node.nodeValue) node.nodeValue = text;
    });
    document.querySelectorAll('.xz-pg-reviews-widget .jdgm-verified-link-wrapper a').forEach(function (link) {
      setAttr(link, 'aria-label', 'Verified By Judge.Me');
    });
    document.querySelectorAll('.xz-pg-reviews-widget .jdgm-row-actions select.jdgm-sort-dropdown').forEach(function (select) {
      sizeSort(select);
      if (!select.__xzSort) { select.__xzSort = true; select.addEventListener('change', function () { sizeSort(select); }); }
    });
    // Review photo lightbox (Judge.me's Magnific Popup): a labelled modal dialog.
    document.querySelectorAll('.jm-mfp-wrap').forEach(function (wrap) {
      setAttr(wrap, 'role', 'dialog');
      setAttr(wrap, 'aria-modal', 'true');
      setAttr(wrap, 'aria-label', 'Review photo');
      // Its close button's only text is the glyph '×' (read as 'times' / 'multiplication').
      var close = wrap.querySelector('.jm-mfp-close');
      if (close) setAttr(close, 'aria-label', 'Close photo');
    });
    syncWriteState();
  }
  // tab switches and the write toggle change classes/styles only: re-sync on their clicks too.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.jdgm-widget, .jdgm-write-review-modal, .jm-mfp-wrap')) scheduleA11y();
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') scheduleA11y();
  }, true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleA11y);

  // Customize the "Write a Review" form name format dropdown:
  // Default to "John S." and hide the Anonymous option
  function customizeNameFormat(form) {
    if (form.dataset.nameFormatCustomized) return;
    var sel = form.querySelector('select[name="reviewer_name_format"]');
    if (!sel) return;
    form.dataset.nameFormatCustomized = '1';
    // Set default to "John S." (last_initial)
    sel.value = 'last_initial';
    // Remove the Anonymous option entirely
    for (var i = sel.options.length - 1; i >= 0; i--) {
      if (sel.options[i].value === 'anonymous') {
        sel.remove(i);
        break;
      }
    }
    // Remove "How we use your data" privacy paragraph
    var paragraphs = form.querySelectorAll('.jdgm-form__fieldset p');
    paragraphs.forEach(function (p) {
      if (p.textContent.indexOf('How we use your data') !== -1) {
        p.parentElement.style.display = 'none';
      }
    });
  }

  function customizeAllForms() {
    var forms = document.querySelectorAll('.jdgm-form');
    forms.forEach(customizeNameFormat);
  }

  // Start observing as soon as possible
  function init() {
    enhanceAll();
    customizeAllForms();
    a11yPass();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
